var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1110_319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1110_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 15.5001H13.3335V13.8334H6.66683V15.5001ZM6.66683 12.1667H13.3335V10.5001H6.66683V12.1667ZM5.00016 18.8334C4.54183 18.8334 4.14947 18.6702 3.82308 18.3438C3.49669 18.0174 3.3335 17.6251 3.3335 17.1667V3.83341C3.3335 3.37508 3.49669 2.98272 3.82308 2.65633C4.14947 2.32994 4.54183 2.16675 5.00016 2.16675H11.6668L16.6668 7.16675V17.1667C16.6668 17.6251 16.5036 18.0174 16.1772 18.3438C15.8509 18.6702 15.4585 18.8334 15.0002 18.8334H5.00016ZM10.8335 8.00008V3.83341H5.00016V17.1667H15.0002V8.00008H10.8335Z",
    fill: "#242634"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.060438520920bc0a1596982e12821265.svg";
export { ForwardRef as ReactComponent };